(() => {
  const root = document.querySelector('#peptiva-ai');
  if (!root) return;
  const endpoint = root.dataset.apiUrl;
  const hr = (root.dataset.lang || '').toLowerCase().startsWith('hr');
  const t = hr ? {
    subtitle: 'Istraživački proizvodi i podrška',
    hello: 'Pozdrav! Ja sam Peptiva AI asistent. Kako vam mogu pomoći?',
    placeholder: 'Pitajte o proizvodima...',
    disclaimer: 'Samo za istraživačke informacije. Nije medicinski savjet.',
    waiting: 'Pripremam odgovor…',
    retrying: 'Veza je usporena. Pokušavam ponovno…',
    offline: 'Veza s asistentom trenutačno nije dostupna. Pokušajte ponovno.'
  } : {
    subtitle: 'Research products & support',
    hello: 'Hello! I am Peptiva AI. How can I help?',
    placeholder: 'Ask about products...',
    disclaimer: 'Research information only. Not medical advice.',
    waiting: 'Preparing your reply…',
    retrying: 'The connection is slow. Retrying…',
    offline: 'The assistant is temporarily unavailable. Please try again.'
  };
  const panel = root.querySelector('.pai-panel');
  const messages = root.querySelector('.pai-messages');
  const form = root.querySelector('form');
  const input = form.querySelector('input');
  const send = form.querySelector('button[type="submit"]');
  const open = root.querySelector('.pai-open');
  const showLatest = () => { messages.scrollTop = messages.scrollHeight; };
  const add = (text, role) => {
    const bubble = document.createElement('div');
    bubble.className = 'pai-bubble ' + role;
    bubble.textContent = text;
    messages.append(bubble);
    showLatest();
    return bubble;
  };
  root.querySelector('[data-i18n=subtitle]').textContent = t.subtitle;
  root.querySelector('[data-i18n=disclaimer]').textContent = t.disclaimer;
  input.placeholder = t.placeholder;
  open.onclick = () => {
    panel.hidden = false;
    open.hidden = true;
    if (!messages.childElementCount) add(t.hello, 'bot');
    showLatest();
  };
  root.querySelector('.pai-close').onclick = () => {
    panel.hidden = true;
    open.hidden = false;
  };
  const request = async (message) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, language: hr ? 'hr' : 'en' }),
        signal: controller.signal
      });
      if ([502, 503, 504].includes(response.status)) return null;
      if (!response.ok) throw new Error('Chat request failed');
      const data = await response.json();
      if (typeof data.reply !== 'string' || !data.reply.trim()) throw new Error('Missing reply');
      return data.reply;
    } finally {
      clearTimeout(timeout);
    }
  };
  form.onsubmit = async (event) => {
    event.preventDefault();
    const message = input.value.trim();
    if (!message || send.disabled) return;
    input.value = '';
    add(message, 'user');
    send.disabled = true;
    const reply = add(t.waiting, 'bot');
    try {
      if (!endpoint) throw new Error('Missing endpoint');
      let answer = await request(message);
      if (answer === null) {
        reply.textContent = t.retrying;
        showLatest();
        answer = await request(message);
      }
      reply.textContent = answer ?? t.offline;
      if (answer === null && !input.value) input.value = message;
    } catch {
      reply.textContent = t.offline;
      if (!input.value) input.value = message;
    } finally {
      send.disabled = false;
      showLatest();
    }
  };
  root.hidden = false;
})();